export enum NavigationMode {
    Single,
    Double
}